export type TItem = {
  name: string;
  type?: "text" | "email" | "password";
  initValue: string;
  placeholder?: string;
  validationRule: object;
};

type TReduce = {
  initialValues: Record<string, string>;
  fields: Array<any>;
  validationRuleObject: Record<string, any>;
};

export const reduceFieldSettings = (list: Array<TItem>) => list.reduce<TReduce>(
  ({ initialValues, fields, validationRuleObject, }, { name, initValue, validationRule, ...rest }) => ({
    initialValues: { ...initialValues, [name]: initValue, },
    fields: [ ...fields, { name, ...rest } ],
    validationRuleObject: { ...validationRuleObject, [name]: validationRule },
  }),
  {
    initialValues: {},
    fields: [],
    validationRuleObject: {},
  },
);
